import { inject, Pipe, PipeTransform } from '@angular/core';

import { VocabularyKey } from './instance-profile';
import { TenantConfig } from './tenant-config';

/**
 * TEC-294: un término del dominio en una plantilla, según la instancia.
 * `{{ 'circuit' | term }}` → "Circuito TEC" en Movilidad; `{{ 'scholarship' | term: 'plural' }}` → "Becas".
 * Impuro a propósito: lee un signal de `TenantConfig` y debe seguirlo si el perfil cambia (login, logout).
 */
@Pipe({ name: 'term', pure: false })
export class TermPipe implements PipeTransform {
  readonly #tenant = inject(TenantConfig);

  transform(key: VocabularyKey, form: 'singular' | 'plural' = 'singular'): string {
    return this.#tenant.term(key, form === 'plural');
  }
}

/**
 * La palabra que concuerda en género con un término: `{{ 'scholarship' | termAgree: 'aplicada' : 'aplicado' }}`
 * ("Beca aplicada" en Movilidad, "Subsidio aplicado" en Passenger).
 */
@Pipe({ name: 'termAgree', pure: false })
export class TermAgreePipe implements PipeTransform {
  readonly #tenant = inject(TenantConfig);

  transform(key: VocabularyKey, feminine: string, masculine: string): string {
    return this.#tenant.agree(key, feminine, masculine);
  }
}
